import { request } from "../../Services/Api"

const BASE_URL = "/business-health/dashboard"

export const getHealthMainInfo = (params) => request.api.get(`${BASE_URL}/main-info/`, params)
export const getHealthOverview = (params) => request.api.get(`${BASE_URL}/overview/`, params)

export const getPreventionRate = (params) => request.api.get(`${BASE_URL}/prevention-rate/`, params)
export const getDataByCardType = (params) => request.api.get(`${BASE_URL}/by-card-type/`, params)
export const getDataByReasonCode = (params) =>
  request.api.get(`${BASE_URL}/by-reason-code/`, params)
export const getDataByCountry = (params) => request.api.get(`${BASE_URL}/by-country/`, params)
export const getDataOlympics = (params) => request.api.get(`${BASE_URL}/olympics/`, params)
export const getRiskLevel = (params) => request.api.get(`${BASE_URL}/risk-level/`, params)
export const getFilterOptions = (params) => request.api.get(`${BASE_URL}/filter-options/`, params)

// BH VAMP
export const getVampMainChart = (params) =>
  request.api.get(`/business-health/vamp-dashboard/vamp_dashboard/`, params)
export const getVampMonitoringProgramChart = (params) =>
  request.api.get(`/business-health/vamp-dashboard/vamp-monitoring-program-chart/`, params)
export const getVampEstimatedProgramStatus = (params) =>
  request.api.get(`/business-health/vamp-dashboard/vamp-estimated-program-status/`, params)

export const getVampDescriptorsList = (params) =>
  request.api.get(`/business-health/vamp-dashboard/descriptors/`, params)

export const getVampEnrollmentData = (params) => {
  return request.api.get(`/business-health/vamp-dashboard/vamp-available-info/`, params)
}

export const createVampEnrollmentRequest = (data) => {
  return request.api.post(`/business-health/vamp-dashboard/request-to-enroll/`, data, {
    params: data?.business_account ? { business_account: data?.business_account } : {}
  })
}

// BH Mastercard (ECP & EFM)
export const getMcMainChart = (params) =>
  request.api.get(`/business-health/mc-dashboard/mc_dashboard/`, params);
export const getMcMonitoringProgramChart = (params) =>
  request.api.get(
    `/business-health/mc-dashboard/ecp-monitoring-program-chart/`,
    params
  );
export const getEfmMonitoringProgramChart = (params) =>
  request.api.get(
    `/business-health/mc-dashboard/efm-monitoring-program-chart/`,
    params
  );
export const getMcEstimatedProgramStatus = (params) =>
  request.api.get(
    `/business-health/mc-dashboard/mc-estimated-program-status/`,
    params
  );
